import { AgenturModel } from 'app/models/agentur.model';
import { BaseEntityStore } from './core/base.entity.store';
import Config from 'Config';
import routes from 'routes';

const path = require('path-browserify');

export class ExportPdfTable {
	title: string = '';
	isHtml: boolean = true;
	data: any;
	forcePageBreak: boolean = false;
}

export interface IPrintPdfOpts {
	tables: ExportPdfTable[];
	versionDate?: string;
	title?: string;
	agt?: AgenturModel;
}

export class PdfStore extends BaseEntityStore<any> {
	apiPath = 'api/pdf/berichte';
	idProp: string = 'inspId';
	createInstances(opts: any): any {
		return opts;
	}

	getPdfLink(fileName: string) {
		const url = new URL(`/api/pdf/download/${fileName}/pdf?c=${new Date().getTime()}`, Config.API_BASE_URL).toString();

		// const p = Config.API_BASE_URL + path.join('/api/pdf/download', fileName, 'pdf?c=' + new Date().getTime());
		return url;
	}
	getPrintinProgressUrl() {
		return ('#' + routes.printing.getPath()) as any;
	}


	async printPdf2(pathToPrint: string, fileName?: string) {
		let toSend = { pathToPrint, fileName };
		const windowReference = window.open();
		windowReference!.opener = null;
		windowReference!.location = this.getPrintinProgressUrl();

		const res = await this.post('pdf2', toSend);
		const url = this.getPdfLink(res.data.outPutFile);
		windowReference!.location = url as any;
	}

	async printAndSavePdf2(pathToPrint: string, fileName: string, reportPath: string) {
		let toSend = { pathToPrint, fileName, saveForBnr: true, reportPath };
		const windowReference = window.open();
		windowReference!.opener = null;
		windowReference!.location = this.getPrintinProgressUrl();

		const res = await this.post('pdf2', toSend);
		const url = this.getPdfLink(res.data.outPutFile);
		windowReference!.location = url as any;
	}

	getSavedPdfDownloadLink(token: string) {
		const url = new URL(`/api/pdf/downloadsaved/${token}?c=${new Date().getTime()}`, Config.API_BASE_URL).toString();
		return url;
	}

	async getSavedPdfLink(id: string): Promise<string> {
		// First get a token for the saved PDF (authenticated request)
		const res = await this.get(`api/pdf/savedtoken/${id}`, false);
		const token = res.data.outPutFile;
		// Return the public download URL with the token
		return this.getSavedPdfDownloadLink(token);
	}

	async openSavedPdf(id: string) {
		const url = await this.getSavedPdfLink(id);
		window.open(url, '_blank');
	}
}
